import React, { useState, useEffect, useRef, useMemo } from 'react'
import { Helmet } from 'react-helmet-async'
import './styles.scss'
import AccountMenu from 'components/User/AccountMenu'
import HistoryPurchasedList from 'components/User/HistoryPurchasedList'

const HistoryPurchased: React.FC = () => {
    useEffect(() => {
        document.body.classList.add("NoneHeaderFooter");

        return () => {
            document.body.classList.remove("NoneHeaderFooter");
        };
    }, []);

    return (
        <>
            <Helmet>
                <title>Sản phẩm đã mua - Dược Tâm Hạnh</title>
                <meta name="description" content="Lịch sử sản phẩm đã mua tại Dược Tâm Hạnh." />
            </Helmet>
            <div className='style_container__3o3Ct'>
                <div className="styles_wrapDirect__RrlO8 MuiBox-root css-0 hidden-1199">
                    <nav className="MuiTypography-root MuiBreadcrumbs-root MuiTypography-body1 MuiTypography-colorTextSecondary" aria-label="breadcrumb">
                        <ol className="MuiBreadcrumbs-ol">
                            <li className="MuiBreadcrumbs-li">
                                <a className="styles_item_breadcrumb__eYGFd" href="/">Trang chủ</a>
                            </li>
                            <li aria-hidden="true" className="MuiBreadcrumbs-separator" ins-init-condition="#Lk11aUJyZWFkY3J1bWJzLW9sIGxpOm5vdCg6Zmlyc3Qp">
                                <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                                    <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
                                </svg>
                            </li>
                            <li className="MuiBreadcrumbs-li" ins-init-condition="#Lk11aUJyZWFkY3J1bWJzLW9sIGxpOm5vdCg6Zmlyc3Qp">
                                <span className="styles_item_breadcrumb__eYGFd styles_last_breadcrumb__c7IQm">Sản phẩm đã mua</span>
                            </li>
                        </ol>
                    </nav>
                </div>
                <div className="jss3">
                    <AccountMenu />
                    <div className="styles_full_width__2R9Yf">
                        <HistoryPurchasedList />
                    </div>
                </div>
            </div>
        </>
    )
}

export default HistoryPurchased
